module.exports = __webpack_public_path__ + "assets/97b2c3f6b9d9128fd694ead2a9d0d393.png";